import { css } from 'astroturf';
import React from 'react';
import { ArrowRight } from 'react-bytesize-icons';
import Hero3D from './Hero-3D';
import Platforms from './Platforms';
import Punchout from './Punchout';
import Circle from './Circle';
import Link from './link';

const styles = css`
  .hero {
    z-index: 1;
    position: relative;
    padding: 70px 3vw 10rem;
    padding-left: calc(3vw + env(safe-area-inset-left, 0));
    padding-right: calc(3vw + env(safe-area-inset-right, 0));
    text-align: center;
    overflow: hidden;
    margin-bottom: -9rem;

    @supports (overflow: clip) {
      overflow: clip visible;

      margin-bottom: 3rem;
      padding: 70px 3vw 1rem;
    }

    & header {
      position: relative;
      padding-bottom: 0rem;
      max-width: 840px;
      margin: 0 auto 4rem;

      @media (min-width: 1024px) {
        padding-bottom: 4rem;
      }

      & > div > svg {
        max-width: 180px;
        width: 100%;
      }
      & h1 {
        font-weight: 900;
        font-size: clamp(25px, 6vw, 50px);
        line-height: 1;
        margin: 0.5rem auto 1.25rem;
        padding-bottom: 0.22ch;
        padding-top: 0.25em;
        color: #0a1530;
        width: 100%;
        max-width: 18ch;
        max-height: calc(1.3 * 4 * clamp(25px, 3.7vw, 42px));
        overflow: hidden;
      }

      & p {
        font-size: 1.1em;
        line-height: 1.5;
        font-weight: 400;
        max-width: 40rem;
        margin: 0 auto 1rem;
        color: #0a1530;

        @media (min-width: 1024px) {
          padding-left: 0.125rem;
          margin-inline: 0;
        }
      }
    }

    @media (min-width: 1024px) {
      padding-top: 100px;

      & .split {
        position: relative;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0 auto;
        max-width: 1200px;

        & > * {
          flex: 1 0 48%;

          &.imageWrapper {
            flex: 1 1 48%;
            padding: 0;
          }
        }

        @media (min-width: 1920px) {
          max-width: 1440px;
          justify-content: center;

          & > * {
            flex: 0 1 720px;
          }
        }

        & header {
          padding-bottom: 0;
          margin-bottom: 0;
          text-align: left;
          margin-right: 2rem;

          & h1 {
            margin-left: 0;
          }

          & h2 {
            margin-left: 0;
          }
        }
      }
    }
  }

  .primaryButton {
    position: relative;
    pointer-events: all;
    margin: 0;
    font-size: calc(14px + 0.5vw);
    font-weight: 700;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(135deg, #2c82ad, #67b26f);
    background: linear-gradient(135deg, oklab(0.61 -0.08 -0.21), oklab(0.66 -0.24 0.16));
    border-radius: 40px;
    text-align: center;
    display: inline-block;
    text-decoration: none;
    line-height: 26px;
    transition: all 0.25s ease-in-out;
    padding: 0;
    margin-bottom: 1.5rem;
    @media (forced-colors: active) {
      border: 1px solid;
    }

    & i {
      position: absolute;
      top: calc(100% + 10px);
      line-height: 1;
      left: -10%;
      right: 0;
      width: 120%;
      text-align: center;
      font-size: 12px;
      font-weight: normal;
      color: #506478;
      background: #f7faff;
      display: block;
      font-style: normal;
    }

    & span {
      position: relative;
      z-index: 1;
      padding: 0.33rem 1rem;
      content: ' ';
      display: block;

      width: calc(100%);
      height: calc(100%);
      z-index: 0;
      opacity: 1;
      transition: background 0.25s ease-in-out;
      border-radius: 40px;
      background: #0a1530;
    }

    & svg {
      vertical-align: middle;
      margin-left: 10px;
    }

    @media (min-width: 600px) {
      & span {
        font-size: 1.125rem;
      }
    }

    &:hocus {
      text-decoration: none;
      & span {
        background: transparent;
      }
    }
  }
`;

export default () => (
  <div className={styles.hero}>
    <div className={styles.split}>
      <header>
        <div className={styles.textwrap}>
          <svg viewBox="0 0 402 97" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect
              x="1.30562"
              y="29.3615"
              width="57"
              height="66"
              rx="5"
              transform="rotate(-5.22773 1.30562 29.3615)"
              stroke="#415377"
              strokeWidth="2"
            />
            <path
              className={styles.tablet}
              d="M44.4633 52.2066C44.0055 45.848 38.3921 40.9886 32.0335 41.4464C25.6283 41.9075 20.8156 47.5176 21.2734 53.8762C21.7345 60.2815 27.2979 65.0975 33.7032 64.6364C40.0617 64.1786 44.9245 58.6119 44.4633 52.2066ZM31.9568 59.3105C31.6965 59.6112 31.1822 59.6483 30.8815 59.3879L25.669 54.8756C25.3683 54.6153 25.3312 54.101 25.5916 53.8003L26.5928 52.6942C26.8498 52.3468 27.3173 52.3131 27.6214 52.6202L31.1766 55.654L37.6848 48.136C37.9417 47.7885 38.4093 47.7548 38.7134 48.0619L39.8628 49.0131C40.1635 49.2734 40.2005 49.7877 39.9402 50.0884L31.9568 59.3105Z"
              fill="#58B993"
            />
            <circle
              cx="35.2352"
              cy="81.9207"
              r="3.56794"
              transform="rotate(-5.22773 35.2352 81.9207)"
              stroke="#415377"
              strokeWidth="2"
            />
            <path
              opacity="0.2"
              d="M78.2045 50.5475C78.2045 50.5475 91.8311 46.7054 102.975 45.8487C114.118 44.992 127.745 47.1499 127.745 47.1499"
              stroke="#415377"
              strokeWidth="2"
            />
            <rect x="142.401" y="1" width="129.656" height="94" rx="5" stroke="#415377" strokeWidth="2" />
            <path
              className={styles.desktop}
              d="M227.243 54.0414C227.243 43.4164 218.493 34.6664 207.868 34.6664C197.165 34.6664 188.493 43.4164 188.493 54.0414C188.493 64.7445 197.165 73.4164 207.868 73.4164C218.493 73.4164 227.243 64.7445 227.243 54.0414ZM205.603 64.3539C205.134 64.8226 204.274 64.8226 203.806 64.3539L195.681 56.2289C195.212 55.7601 195.212 54.9008 195.681 54.432L197.478 52.7133C197.946 52.1664 198.728 52.1664 199.196 52.7133L204.743 58.182L216.462 46.4633C216.931 45.9164 217.712 45.9164 218.181 46.4633L219.978 48.182C220.446 48.6508 220.446 49.5101 219.978 49.9789L205.603 64.3539Z"
              fill="#58B993"
            />
            <line x1="142.745" y1="13.9375" x2="272.057" y2="13.9375" stroke="#415377" strokeWidth="2" />
            <path
              opacity="0.2"
              d="M287.362 44.7053C287.362 44.7053 301.509 44.1583 312.544 45.9329C323.579 47.7074 336.322 52.9939 336.322 52.9939"
              stroke="#415377"
              strokeWidth="2"
            />
            <rect
              x="364.64"
              y="22.8397"
              width="37"
              height="66"
              rx="5"
              transform="rotate(12.255 364.64 22.8397)"
              stroke="#415377"
              strokeWidth="2"
            />
            <path
              className={styles.mobile}
              d="M382.274 62.7157C383.145 58.556 380.437 54.4126 376.278 53.5411C372.087 52.6631 367.975 55.3773 367.103 59.537C366.225 63.7273 368.909 67.8336 373.099 68.7116C377.259 69.5832 381.396 66.9059 382.274 62.7157ZM372.955 64.9778C372.733 65.1229 372.397 65.0524 372.252 64.8304L369.738 60.983C369.592 60.761 369.663 60.4246 369.885 60.2795L370.729 59.754C370.958 59.5784 371.264 59.6425 371.402 59.895L373.125 62.491L378.674 58.8645C378.903 58.6888 379.209 58.7529 379.347 59.0055L379.91 59.8257C380.055 60.0477 379.984 60.3842 379.762 60.5292L372.955 64.9778Z"
              fill="#58B993"
            />
            <rect
              x="369.23"
              y="29.9765"
              width="7"
              height="7"
              rx="3.5"
              transform="rotate(12.255 369.23 29.9765)"
              stroke="#415377"
              strokeWidth="2"
            />
          </svg>
          <h1 aria-label="The browser for ambitious web developers.">
            Like using <Circle>DevTools</Circle> with <Punchout>cheats enabled</Punchout>.
          </h1>
          <p>
            Build better websites in less time with a stand-alone browser that makes your site more responsive, more
            accessible and more performant. Save hours on each project, love every minute of it.
          </p>

          <div>
            <Link className={styles.primaryButton} to="https://dashboard.polypane.app/register/">
              <span>
                Try Polypane for free <ArrowRight width={16} height={16} strokeWidth="4px" />
              </span>
              <i>No credit card needed.</i>
            </Link>
            <span>
              <Platforms />
            </span>
          </div>
        </div>
      </header>

      <div className={styles.imageWrapper}>
        <Hero3D />
      </div>
    </div>
  </div>
);
